import React from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Button,
  Paper,
} from "@mui/material";

import "../styles/memoHebdo.css";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import ArticleIcon from "@mui/icons-material/Article";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// FORM
import ArticleForm from "../components/ArticleForm";

function EditArticle() {
  const navigate = useNavigate();
  const { t } = useTranslation(["memohebdo"]);
  return (
    <Box className="mh-page">
      {/* ================= HEADER ================= */}
      <Box className="mh-header-card">
        {/* TOP BLUE BAR */}
        <Box className="mh-header-topbar" />

        {/* CONTENT */}
        <Box className="mh-header-content">
          {/* TITLE ROW */}
          <Box className="mh-header-title-row">
            {/* LEFT */}
            <Box>
              <Typography className="mh-subtitle">
                {t("memoHebdo.editPage.subtitle")}
              </Typography>
            </Box>

            {/* RIGHT */}
            <Button
              startIcon={<ArrowBackIcon />}
              variant="outlined"
              onClick={() => navigate("/ArticleManagement")}
              sx={{
                textTransform: "none",
                borderRadius: "12px",
                fontWeight: 700,
                px: 2.5,
              }}
            >
              {t("memoHebdo.buttons.back")}
            </Button>
          </Box>

          {/* ================= BREADCRUMBS ================= */}
          <Breadcrumbs>
            <Link
              underline="hover"
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => navigate("/")}
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
              {t("memoHebdo.breadcrumbs.home")}
            </Link>

            <Link
              underline="hover"
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => navigate("/ArticleManagement")}
            >
              <ArticleIcon sx={{ mr: 0.5 }} fontSize="small" />
              {t("memoHebdo.breadcrumbs.articleManagement")}
            </Link>

            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
              }}
              color="text.primary"
            >
              <EditIcon sx={{ mr: 0.5 }} fontSize="small" />
              {t("common.edit")}
            </Typography>
          </Breadcrumbs>
        </Box>
      </Box>

      {/* ================= CONTENT ================= */}
      <Paper
        elevation={2}
        sx={{
          p: 4,
          borderRadius: "20px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        }}
      >
        <ArticleForm isEdit />
      </Paper>
    </Box>
  );
}

export default EditArticle;
